export const comingSoon = {
	bars: {
		title: "Adicionar Bares",
		message: "Esta funcionalidade será implementada em breve",
	},
	mountableProduct: {
		title: "Produto montável",
		message: "Esta funcionalidade será implementada em breve",
	},
	technicalSheet: {
		title: "Adicionar ficha técnica",
		message: "Esta funcionalidade será implementada em breve",
	},
};
